module.exports = __webpack_public_path__ + "static/media/marca-ucsc.1c1a8713.jpg";